import {Col, Row} from "react-bootstrap";
import React, {Component} from "react";
import './Contact.css';
import {portfolioData, sectionHeaders, mailLink} from "../../../data/data";

class Contact extends Component {
    render() {
        return (
            <div id='contact' className={'px-4 py-5 mt-5'}>
                {sectionHeaders('contact')}
                <Row className={'py-5'}>
                    <Col md={5}>
                        <span style={{fontSize: '3em'}}><strong>Get in touch</strong></span>
                    </Col>
                    <Col md={7} className={'py-3'} style={{fontSize: '1.2em', fontWeight: 500}}>
                        <div>{portfolioData.contact.promoContent}</div>
                        <br/>
                        <a href={mailLink}>
                        <span className={'pills header-menu-item'}
                              style={{backgroundColor: '#2196f33d', color: '#2196f3'}}>
                            Say Hello
                        </span>
                        </a>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Contact;